import { useApi } from '#shared/providers/Api';
import useUsers from './useUsers';
import unwrap from './unwrap';

export default function useResetPassword() {
  const api = useApi();
  const { account } = useUsers();

  function resetPassword(params: { Username: string }) {
    return unwrap(api.postClientResetPasswordEmail(params, undefined, account.bearer));
  }

  return { resetPassword };
}
